// src/components/Logs/LogsTable.js
import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
  CircularProgress,
  Box,
  Typography
} from '@mui/material';
import {
  Visibility as VisibilityIcon,
  Security as SecurityIcon,
  Warning as WarningIcon
} from '@mui/icons-material';
import { formatarData } from '../../utils/formatters';

const LogsTable = ({ logs, loading, onDetailsClick }) => {
  console.log('Logs recebidos na tabela:', logs); // Debug
  const getNivelSensibilidadeColor = (nivel) => {
    switch (nivel) {
      case 'ALTO': return 'error';
      case 'MEDIO': return 'warning';
      case 'BAIXO': return 'success';
      default: return 'default';
    }
  };

  const getTipoLogIcon = (tipo) => {
    switch (tipo) {
      case 'SEGURANCA': return <SecurityIcon fontSize="small" />;
      case 'SISTEMA': return <WarningIcon fontSize="small" />;
      default: return null;
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (!logs.length) {
    return (
      <Box p={3} textAlign="center">
        <Typography color="textSecondary">
          Nenhum log encontrado
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Data/Hora</TableCell>
            <TableCell>Usuário</TableCell>
            <TableCell>Ação</TableCell>
            <TableCell>Entidade</TableCell>
            <TableCell>Tipo</TableCell>
            <TableCell>Sensibilidade</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="center">Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {logs.map((log) => (
            <TableRow key={log.id}>
              <TableCell>{formatarData(log.createdAt)}</TableCell>
              <TableCell>{log.usuario?.nome || 'Sistema'}</TableCell>
              <TableCell>{log.acao}</TableCell>
              <TableCell>
                {log.entidade}
                {log.entidadeId && ` #${log.entidadeId}`}
              </TableCell>
              <TableCell>
                <Chip
                  icon={getTipoLogIcon(log.tipoLog)}
                  label={log.tipoLog}
                  size="small"
                  variant="outlined"
                />
              </TableCell>
              <TableCell>
                <Chip
                  label={log.nivelSensibilidade}
                  size="small"
                  color={getNivelSensibilidadeColor(log.nivelSensibilidade)}
                />
              </TableCell>
              <TableCell>
                <Chip
                  label={log.status}
                  size="small"
                  color={log.status >= 200 && log.status < 300 ? 'success' : 'error'}
                />
              </TableCell>
              <TableCell align="center">
                <IconButton 
                  size="small"
                  onClick={() => onDetailsClick(log)}
                >
                  <VisibilityIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

LogsTable.propTypes = {
  logs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      createdAt: PropTypes.string.isRequired,
      usuario: PropTypes.shape({
        nome: PropTypes.string
      }),
      acao: PropTypes.string.isRequired,
      entidade: PropTypes.string.isRequired,
      entidadeId: PropTypes.number,
      tipoLog: PropTypes.string.isRequired,
      nivelSensibilidade: PropTypes.string.isRequired,
      status: PropTypes.number.isRequired
    })
  ).isRequired,
  loading: PropTypes.bool.isRequired,
  onDetailsClick: PropTypes.func.isRequired
};

export default LogsTable;
